import { BaseService } from "./BaseService";
import {
  CatalogFeature,
  CreateFeatureDto,
  ListFeaturesQuery,
  UpdateFeatureDto,
} from "@/types/catalog-feature";

class CatalogFeaturesService extends BaseService {
  private readonly basePath = "/admin/subscriptions/features";

  constructor() {
    super();
  }

  async getFeatures(query?: ListFeaturesQuery): Promise<CatalogFeature[]> {
    let params: Record<string, string> | undefined;
    if (query?.type) {
      params = { type: query.type };
    }
    const raw = await this.get<CatalogFeature[]>(this.basePath, params);
    return Array.isArray(raw) ? raw : [];
  }

  createFeature(dto: CreateFeatureDto): Promise<CatalogFeature> {
    return this.post<CatalogFeature>(this.basePath, dto);
  }

  patchFeature(id: string, dto: UpdateFeatureDto): Promise<CatalogFeature> {
    return this.patch<CatalogFeature>(`${this.basePath}/${id}`, dto);
  }

  deleteFeature(id: string): Promise<void> {
    return this.delete<void>(`${this.basePath}/${id}`);
  }
}

export const catalogFeaturesService = new CatalogFeaturesService();
